import { ConsumingActivity } from 'hooks/data/datasets/consumingActivities/types';

export const compoundActivityName = (item: ConsumingActivity) => `${item.activity_name}, ${item.geography}`;
